import axios from 'axios'
import api from '@/api/api-endpoints'
import qs from 'qs'
import Notify from 'quasar/src/plugins/Notify.js';
import { modules } from '@/store'
import router from '@/router'
import { preventRedirects } from '@/plugins/urlPaths'
import { createAsyncMutation, doAsyncGet, doAsyncPost, doAsyncPut } from '@/api/async-util'

const resetTypes = (commit) => {

    Object.values(modules).forEach(module => {
        if (!module?.types) return
        Object.keys(module?.types).forEach(type => {
            commit(module.types[type].BASE, { type: module.types[type].FAILURE, error: null, statusCode: null })
            commit(module.types[type].BASE, { type: module.types[type].SUCCESS, value: {} })
        })
    })

}

const types = {
    THROW_TEST_SERVER_ERROR: createAsyncMutation('THROW_TEST_SERVER_ERROR'),
}

const auth = {
    state: {
        status: '',
        token: JSON.parse(localStorage.getItem('token')) || null,
        user: JSON.parse(localStorage.getItem('user')) || null,
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, payload) {
            state.status = 'success'
            state.token = payload.token
            state.user = payload.user
        },
        auth_error(state) {
            state.status = 'error'
        },
        auth_clear(state) {
            state.status = ''
        },
        logout(state) {
            state.status = ''
            state.token = null
            state.user = null
        },
    },
    actions: {
        login({ commit }, user) {
            const requestBody = {
                grant_type: 'password',
                username: user.username,
                password: user.password,
            }

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios.post(api.login, qs.stringify(requestBody), config)
                    .then(resp => {
                        const token = {
                            "access_token": resp.data.access_token,
                            "token_type": resp.data.token_type,
                            "expires_in": new Date(new Date().getTime() + resp.data.expires_in * (21600 / 604800) * 1000)

                            //Token expires in 6 hours: "expires_in": new Date(new Date().getTime() + resp.data.expires_in * (21600 / 604800) * 1000)

                            //For testing purposes, token expires in 1 minute:
                            //"expires_in": new Date(new Date().getTime() + 1 * 60 * 1000)
                        }

                        const user = { id: resp.data.id, username: resp.data.userName, roles: resp.data.roles, emailConfirmed: resp.data.emailConfirmed }
                        const payload = { token: token, user: user }
                        localStorage.setItem('token', JSON.stringify(token))
                        localStorage.setItem('user', JSON.stringify(user))
                        axios.defaults.headers.common['Authorization'] = token.token_type + " " + token.access_token
                        commit('auth_success', payload)

                        this.dispatch('getAccountInfoByEmail', user.username).then(() => {
                            this.dispatch('updateCartCustomer', this.state.getAccountInfoData)
                        })

                        if (user.emailConfirmed && !preventRedirects.includes(router.currentRoute.path)) {
                            Notify.create({
                                badgeClass: 'hidden',
                                type: 'positive',
                                position: 'bottom-right',
                                message: 'You have signed in'
                            })
                        }
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        if (err.response) {
                            reject(err)
                        } else {
                            reject({ message: 'Failed to connect to authentication server' })
                        }
                    })
            })
        },

        logout({ commit }) {
            return new Promise((resolve, reject) => {
                commit('logout')
                commit('logout_cart')
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                delete axios.defaults.headers.common['Authorization']
                if (!preventRedirects.includes(router.currentRoute.path)) {
                    Notify.create({
                        badgeClass: 'hidden',
                        type: 'info',
                        position: 'bottom-right',
                        message: 'You have been signed out'
                    })
                }
                resetTypes(commit)
                commit('reset_info_software')
                resolve()
            })
        },

        throwTestServerError(store) {
            let url = api.error + 'TestNotify'
            return doAsyncGet(store, { url, mutationTypes: types.THROW_TEST_SERVER_ERROR })
        },

    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        authUser: state => state.user,
    },
    types: types
}

export default auth
